// Facts about an article that can be worked out from its document alone, so opening a page needs only the
// document (fetched by blogId) and not the whole index row.
import { plainText } from './renderer/Inlines';

function blockWords(block) {
  switch (block?.type) {
    case 'heading':
    case 'paragraph':
    case 'quote':
      return plainText(block.children);
    case 'list':
      return (block.items || []).map((item) => `${plainText(item.children)} ${blockWords({ ...item.list })}`).join(' ');
    case 'table':
      return [
        ...(block.columns || []).map((c) => c.label),
        ...(block.rows || []).flatMap((row) => (block.columns || []).map((c) => row[c.key] || '')),
      ].join(' ');
    case 'image':
      return block.caption || '';
    default:
      return '';
  }
}

export function articleInfo(doc) {
  const words = (doc.content || []).map(blockWords).join(' ').split(/\s+/).filter(Boolean).length;
  return {
    type: doc.type,
    slug: doc.meta?.slug,
    wordCount: words,
    readingTimeMinutes: Math.max(1, Math.round(words / 200)),
    sourceCreated: doc.created_at || doc.source?.created || null,
    sourceModified: doc.updated_at || doc.source?.modified || doc.created_at || null,
  };
}
